import { Component, inject } from '@angular/core';
import { UiFeedbackService } from './ui-feedback.service';

@Component({
  selector: 'app-ui-feedback',
  standalone: true,
  template: `
    <div class="ui-toast-stack" aria-live="polite" aria-atomic="true">
      @for (toast of ui.toasts(); track toast.id) {
        <div class="ui-toast" [class]="'ui-toast--' + toast.kind" role="status">
          <span class="material-symbols-outlined ui-toast__icon" aria-hidden="true">
            {{
              toast.kind === 'success'
                ? 'check_circle'
                : toast.kind === 'error'
                  ? 'error'
                  : 'info'
            }}
          </span>
          <div class="ui-toast__body">
            <p class="ui-toast__title">{{ toast.title }}</p>
            <p class="ui-toast__message">{{ toast.message }}</p>
          </div>
          <button
            type="button"
            class="ui-toast__close"
            (click)="ui.dismiss(toast.id)"
            aria-label="Cerrar"
          >
            <span class="material-symbols-outlined" aria-hidden="true">close</span>
          </button>
        </div>
      }
    </div>

    @if (ui.dialog(); as dlg) {
      <div
        class="modal-backdrop ui-dialog-backdrop"
        (click)="ui.resolveDialog(null)"
        role="presentation"
      >
        <div
          class="modal-panel ui-dialog-panel"
          (click)="$event.stopPropagation()"
          role="alertdialog"
          [attr.aria-labelledby]="'ui-dialog-title'"
        >
          <div class="modal-header !items-center">
            <div class="flex items-start gap-3 min-w-0">
              <span
                class="material-symbols-outlined ui-dialog__icon"
                [class.ui-dialog__icon--danger]="dlg.mode === 'confirm' && dlg.danger"
                aria-hidden="true"
              >
                {{ dlg.mode === 'confirm' && dlg.danger ? 'warning' : 'help' }}
              </span>
              <div class="min-w-0">
                <h2 id="ui-dialog-title" class="page-title !text-xl mt-0 mb-0">
                  {{ dlg.title }}
                </h2>
              </div>
            </div>
            <button class="btn-ghost !min-h-0 !px-2" type="button" (click)="ui.resolveDialog(null)">
              Cerrar
            </button>
          </div>
          <div class="modal-body space-y-5">
            <p class="m-0 text-sm text-slate-600 whitespace-pre-line">{{ dlg.message }}</p>
            <div class="flex flex-wrap justify-end gap-2">
              @if (dlg.mode === 'confirm') {
                <button class="btn-ghost" type="button" (click)="ui.resolveDialog(false)">
                  {{ dlg.cancelLabel }}
                </button>
                <button
                  type="button"
                  [class]="dlg.danger ? 'btn-danger' : 'btn-primary'"
                  (click)="ui.resolveDialog(true)"
                >
                  {{ dlg.confirmLabel }}
                </button>
              } @else {
                @for (action of dlg.actions; track action.id) {
                  <button
                    type="button"
                    [class]="
                      action.variant === 'danger'
                        ? 'btn-danger'
                        : action.variant === 'ghost'
                          ? 'btn-ghost'
                          : 'btn-primary'
                    "
                    (click)="ui.resolveDialog(action.id)"
                  >
                    {{ action.label }}
                  </button>
                }
              }
            </div>
          </div>
        </div>
      </div>
    }
  `,
})
export class UiFeedbackHostComponent {
  readonly ui = inject(UiFeedbackService);
}
